import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTag } from '@fortawesome/free-solid-svg-icons';

export interface TagBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  tag: {
    id?: string | number;
    name: string;
    color?: string | null;
  };
  size?: 'xs' | 'sm' | 'md';
  className?: string;
  folderName?: string;
  onClick?: (tag: any) => void;
  prefixChildren?: React.ReactNode;
  children?: React.ReactNode;
}

export const TagBadge: React.FC<TagBadgeProps> = ({
  tag,
  size = 'sm',
  className = '',
  folderName,
  onClick,
  prefixChildren,
  children,
  ...props
}) => {
  const baseColor = tag.color || '#888888';
  
  const sizeClasses = {
    xs: 'text-[10px] px-1.5 py-0.5 gap-1',
    sm: 'text-xs px-2 py-0.5 gap-1.5',
    md: 'text-sm px-2.5 py-1 gap-2',
  };

  const iconSizes = {
    xs: 'w-2.5 h-2.5',
    sm: 'w-3 h-3',
    md: 'w-3.5 h-3.5',
  };

  return (
    <span
      data-ui="tag-badge"
      className={`tag-badge inline-flex items-center rounded-full border truncate transition-all duration-200 ${sizeClasses[size]} ${onClick ? 'cursor-pointer' : ''} ${className}`}
      style={{ '--tag-color': baseColor } as React.CSSProperties}
      title={folderName ? `${tag.name} (${folderName})` : tag.name}
      onClick={onClick ? () => onClick(tag) : undefined}
      {...props}
    >
      {prefixChildren}
      <FontAwesomeIcon
        icon={faTag}
        className={`tag-badge-icon flex-shrink-0 ${iconSizes[size]}`}
      />
      <span className="truncate flex-1 font-medium">{tag.name}</span>
      {folderName && (
        <span className="tag-badge-folder flex-shrink-0 text-[0.85em]">/{folderName}</span>
      )}
      {children}
    </span>
  );
};
